import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SidebarLink, linkCss } from './SidebarLink';

interface Props {
  items: Array<{
    name: string;
    url: string;
    active: boolean;
  }>;
  handleLogout?: () => void;
  withoutLogout?: boolean;
}

function Sidebar({ items, handleLogout, withoutLogout }: Props) {
  const articlesComponent =
    items &&
    items.map((s, i) => {
      return (
        <SidebarLink url={s.url} key={i} title={s.name} active={s.active} />
      );
    });

  return (
    <Wrapper>
      <SitemapWrapper>
        {articlesComponent}
        {!withoutLogout && (
          <LogoutButton onClick={handleLogout}>{'Odhlásiť sa'}</LogoutButton>
        )}
      </SitemapWrapper>
    </Wrapper>
  );
}

const SitemapWrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(324)};
  overflow-y: auto;

  ${({ theme }) => theme.mediab.l1300`
    max-width: ${rem(200)};
  `};

  ${({ theme }) => theme.mediab.l1150`
    max-width: ${rem(180)};
  `};

  ${({ theme }) => theme.mediab.l925`
    white-space: nowrap;
    flex-flow: row;
    margin:0;
    padding: ${rem(24)} 0;
    max-width: initial;
    border-bottom: ${theme.borders.primary};
    padding: ${rem(24)} ${rem(16)};
    margin: 0 auto;
    width: 100%;
  `}
`;

const Wrapper = styled.div`
  margin-right: ${rem(36)};
  min-width: ${rem(200)};

  ${({ theme }) => theme.mediab.l925`
    margin-right: -${rem(16)};
    margin-left: -${rem(16)};
  `}
`;

const LogoutButton = styled.span`
  ${linkCss};
  cursor: pointer;
`;

export { Sidebar };
